import { render, staticRenderFns } from "./MasterSite.vue?vue&type=template&id=ff244b86&scoped=true&lang=pug&"
import script from "./scripts/MasterSite.js?vue&type=script&lang=js&"
export * from "./scripts/MasterSite.js?vue&type=script&lang=js&"
import style0 from "./MasterSite.vue?vue&type=style&index=0&id=ff244b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff244b86",
  null
  
)

export default component.exports